import React from 'react';


const CategorySmallCards = ({image}) => {
  return (
    <div className='relative w-full'>
        <div className="group max-w-sm    border border-gray-300 hover:shadow-md  mx-0.5 rounded-lg shadow-sm ">
    <a href="/" className='w-full bg-slate-100   overflow-hidden mb-2'>
        <img className="rounded-t-sm lg:px-6 px-2 py-2 group-hover:scale-110 duration-300 transition-all " src={image} alt="" />
    </a>
    <div className=" py-2 px-0.5 lg:p-3 ">
       <h1 className='text-center md:text-sm text-xs font-medium md:font-semibold md:text-md w-full '>smart Phones</h1>
    </div>
</div>
    </div>
  )
}

export default CategorySmallCards